import { render, staticRenderFns } from "./CrudIdea.vue?vue&type=template&id=4d6d0ae8&"
import script from "./CrudIdea.vue?vue&type=script&lang=js&"
export * from "./CrudIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports